export default __webpack_public_path__ + "static/lutein-spasim-zrenieto-header-1ca821ec150bec9a7e2e4a9a97e6cb25.jpg";